import styled from 'styled-components';
import { Box } from '@bpba/ui-components';

type StyledBoxProps = {
  gap?: string;
  whiteSpace?: string;
};

export const StyledBox = styled(Box)<StyledBoxProps>`
  gap: ${({ gap = '16px' }) => gap};
  white-space: ${({ whiteSpace = 'normal' }) => whiteSpace};
`;
